import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../diagnosesAction';
import fetchApi from "./fetchApi";

function fetchDiagnosesAction() {
  return fetchApi('/v1/fc_api/diagnoses_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchDiagnosesAction;
